module.exports = __webpack_public_path__ + "static/media/bgLocation.a172b4c3.png";